import React, { useState, useEffect } from 'react';

// [1] 데이터: 문구와 내용을 조금 더 '브랜드'스럽게 다듬었습니다.
const QUESTIONS = [
  {
    id: 1,
    question: "Q1. 오후 4시, 당신의 머리카락 상태는?",
    sub: "가장 비슷한 느낌을 하나만 골라주세요.",
    options: [
      { text: "💦 앞머리가 떡지고 유분기가 돈다", type: "A" },
      { text: "🌵 두피가 당기거나 가려워서 긁게 된다", type: "B" },
      { text: "🍂 힘없이 축 처지고 볼륨이 죽는다", type: "C" },
    ],
  },
  {
    id: 2,
    question: "Q2. 거울을 볼 때 가장 신경 쓰이는 것은?",
    sub: "육안으로 확인되는 증상을 체크해주세요.",
    options: [
      { text: "🔴 붉게 올라온 뾰루지와 냄새", type: "A" },
      { text: "❄️ 어깨 위로 떨어지는 하얀 각질", type: "B" },
      { text: "📉 휑해 보이는 가르마와 정수리", type: "C" },
    ],
  },
  {
    id: 3,
    question: "Q3. 평소 생활 습관을 체크해주세요.",
    sub: "두피는 생활 습관의 거울입니다.",
    options: [
      { text: "튀김/육류 위주 식사 & 열이 많음", type: "A" },
      { text: "잦은 염색/펌 & 뜨거운 바람 건조", type: "B" },
      { text: "수면 부족 & 스트레스/다이어트 중", type: "C" },
    ],
  },
];

const RESULTS = {
  A: {
    title: "TYPE A. 산유국 폭발형",
    subtitle: "과잉 피지 & 지루성 주의",
    desc: "피지 분비량이 정상 범위를 초과했습니다. 모공이 막혀 트러블이 생기기 쉬운 환경입니다.",
    solutionTitle: "Cooling & Deep Clean",
    solution: "모공 속 피지를 녹이는 '쿨링 스케일러'",
    color: "#00695c", 
    bgColor: "#e0f2f1"
  },
  B: {
    title: "TYPE B. 사막화 경보형",
    subtitle: "수분 부족 & 민감성",
    desc: "두피 장벽이 무너져 외부 자극에 매우 취약합니다. 각질 제거보다는 '진정'이 시급합니다.",
    solutionTitle: "Moisture & Calming",
    solution: "장벽을 세우는 '약산성 앰플'",
    color: "#c62828",
    bgColor: "#ffebee"
  },
  C: {
    title: "TYPE C. 뿌리 실종형",
    subtitle: "영양 부족 & 탈모 시그널",
    desc: "모근이 모발을 잡는 힘이 약해졌습니다. 지금 관리하지 않으면 회복 시간이 2배 걸립니다.",
    solutionTitle: "Nutrition & Strengthening",
    solution: "모근 강화 '고농축 단백질 토닉'",
    color: "#4e342e",
    bgColor: "#efebe9"
  },
};

// [2] 컴포넌트 시작
export default function App() {
  const [step, setStep] = useState('intro'); 
  const [currentQ, setCurrentQ] = useState(0);
  const [scores, setScores] = useState({ A: 0, B: 0, C: 0 });
  const [finalType, setFinalType] = useState('A');
  const [fade, setFade] = useState(true); // 애니메이션 트리거

  // 화면 전환 시 페이드 효과 함수
  const transitionTo = (nextStep) => {
    setFade(false);
    setTimeout(() => {
      setStep(nextStep);
      setFade(true);
    }, 300);
  };

  const handleAnswer = (type) => {
    const newScores = { ...scores, [type]: scores[type] + 1 };
    setScores(newScores);

    if (currentQ < QUESTIONS.length - 1) {
      setFade(false);
      setTimeout(() => {
        setCurrentQ(currentQ + 1);
        setFade(true);
      }, 300);
    } else {
      const resultType = Object.keys(newScores).reduce((a, b) => 
        newScores[a] > newScores[b] ? a : b
      );
      setFinalType(resultType);
      transitionTo('analyzing');
    }
  };

  useEffect(() => {
    if (step === 'analyzing') {
      const timer = setTimeout(() => transitionTo('result'), 2500);
      return () => clearTimeout(timer);
    }
  }, [step]);

  // CSS 스타일 (디자인 시스템)
  const styles = {
    wrapper: {
      minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      backgroundColor: '#f4f6f8', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      padding: '20px'
    },
    container: {
      width: '100%', maxWidth: '420px', backgroundColor: '#fff', borderRadius: '24px',
      boxShadow: '0 10px 40px rgba(0,0,0,0.08)', overflow: 'hidden', position: 'relative',
      minHeight: '600px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'
    },
    content: {
      padding: '40px 30px', flex: 1, display: 'flex', flexDirection: 'column',
      opacity: fade ? 1 : 0, transition: 'opacity 0.3s ease-in-out', // 페이드 애니메이션 적용
      alignItems: 'center', justifyContent: 'center'
    },
    brand: {
      fontSize: '12px', fontWeight: 'bold', letterSpacing: '2px', color: '#aaa', marginBottom: '10px', textTransform: 'uppercase'
    },
    title: {
      fontSize: '28px', fontWeight: '800', color: '#111', marginBottom: '16px', lineHeight: '1.3', textAlign: 'center'
    },
    desc: {
      fontSize: '16px', color: '#666', lineHeight: '1.6', textAlign: 'center', marginBottom: '40px'
    },
    button: {
      width: '100%', padding: '20px', borderRadius: '16px', border: '1px solid #eee',
      backgroundColor: '#fff', fontSize: '16px', fontWeight: '600', color: '#333',
      cursor: 'pointer', marginBottom: '12px', textAlign: 'left',
      boxShadow: '0 2px 5px rgba(0,0,0,0.03)', transition: 'all 0.2s ease'
    },
    mainBtn: {
      width: '100%', padding: '20px', borderRadius: '16px', border: 'none',
      background: 'linear-gradient(135deg, #004d40 0%, #00695c 100%)', // 그라데이션 버튼
      color: '#fff', fontSize: '18px', fontWeight: 'bold', cursor: 'pointer',
      marginTop: 'auto', boxShadow: '0 5px 15px rgba(0,77,64,0.3)'
    },
    barBg: { width: '100%', height: '6px', backgroundColor: '#eee', position: 'absolute', top: 0, left: 0 },
    barFill: { height: '100%', backgroundColor: '#004d40', width: `${((currentQ + 1) / 3) * 100}%`, transition: 'width 0.5s ease' },
    
    // 결과 페이지 전용 스타일
    resultCard: {
      backgroundColor: RESULTS[finalType].bgColor, borderRadius: '20px', padding: '30px', width: '100%',
      marginBottom: '30px', textAlign: 'center'
    },
    tag: {
      display: 'inline-block', padding: '6px 12px', borderRadius: '20px', backgroundColor: 'rgba(255,255,255,0.8)',
      fontSize: '13px', fontWeight: 'bold', color: RESULTS[finalType].color, marginBottom: '15px'
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        
        {/* Step 1: 인트로 */}
        {step === 'intro' && (
          <div style={styles.content}>
            <p style={styles.brand}>PREMIUM SCALP SOLUTION</p>
            <h1 style={styles.title}>당신의 두피 나이,<br/>확인해 보셨나요?</h1>
            <p style={styles.desc}>
              전문가와 함께하는<br/>
              1:1 맞춤 두피 컨설팅 서비스
            </p>
            <div style={{fontSize: '60px', marginBottom: '40px'}}>🧴</div>
            <button 
              style={styles.mainBtn} 
              onClick={() => transitionTo('quiz')}
            >
              내 두피 진단하기
            </button>
          </div>
        )}

        {/* Step 2: 퀴즈 */}
        {step === 'quiz' && (
          <>
            <div style={styles.barBg}><div style={styles.barFill}></div></div>
            <div style={{...styles.content, alignItems: 'stretch', justifyContent: 'flex-start', paddingTop: '60px'}}>
              <span style={{color: '#004d40', fontWeight: 'bold', marginBottom: '10px'}}>Q{currentQ + 1}.</span>
              <h2 style={{fontSize: '22px', fontWeight: 'bold', marginBottom: '8px', color: '#222'}}>
                {QUESTIONS[currentQ].question}
              </h2>
              <p style={{fontSize: '14px', color: '#888', marginBottom: '40px'}}>
                {QUESTIONS[currentQ].sub}
              </p>
              
              {QUESTIONS[currentQ].options.map((opt, idx) => (
                <button 
                  key={idx} 
                  style={styles.button}
                  onClick={() => handleAnswer(opt.type)}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.borderColor = '#004d40';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.borderColor = '#eee';
                  }}
                >
                  {opt.text}
                </button>
              ))}
            </div>
          </>
        )}

        {/* Step 3: 분석 중 */}
        {step === 'analyzing' && (
          <div style={styles.content}>
            <div style={{fontSize: '50px', marginBottom: '20px'}}>🔍</div>
            <h2 style={{fontSize: '22px', color: '#333', marginBottom: '10px'}}>분석 중입니다...</h2>
            <p style={{color: '#888'}}>고객님의 라이프스타일과<br/>두피 타입을 매칭하고 있습니다.</p>
          </div>
        )}

        {/* Step 4: 결과 */}
        {step === 'result' && (
          <div style={{...styles.content, justifyContent: 'flex-start', paddingTop: '40px'}}>
            <p style={styles.brand}>DIAGNOSIS RESULT</p>
            
            <div style={styles.resultCard}>
              <span style={styles.tag}>{RESULTS[finalType].subtitle}</span>
              <h2 style={{fontSize: '24px', fontWeight: '800', color: RESULTS[finalType].color, marginBottom: '10px'}}>
                {RESULTS[finalType].title}
              </h2>
              <p style={{fontSize: '15px', color: '#555', lineHeight: '1.5'}}>
                {RESULTS[finalType].desc}
              </p>
            </div>

            <div style={{width: '100%', textAlign: 'left', padding: '0 10px'}}>
              <p style={{fontWeight: 'bold', color: '#333', marginBottom: '15px'}}>🩺 닥터의 처방전</p>
              <div style={{display: 'flex', alignItems: 'center', marginBottom: '30px'}}>
                <div style={{fontSize: '40px', marginRight: '15px'}}>💊</div>
                <div>
                  <div style={{fontSize: '13px', color: '#004d40', fontWeight: 'bold'}}>{RESULTS[finalType].solutionTitle}</div>
                  <div style={{fontSize: '16px', color: '#333'}}>{RESULTS[finalType].solution}</div>
                </div>
              </div>
            </div>

            <button 
              style={styles.mainBtn} 
              onClick={() => alert('이 버튼을 누르면 자사몰 구매 페이지로 이동합니다.')}
            >
              맞춤 솔루션 30% 할인받기
            </button>
             <p style={{marginTop:'20px', fontSize:'13px', color:'#aaa', textDecoration: 'underline', cursor: 'pointer'}} onClick={() => window.location.reload()}>
              다시 검사하기
            </p>
          </div>
        )}
        
      </div>
    </div>
  );
}